import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../Images";
import InvestorDropDown from "./InvestorDropDown";

const Header = () => {
  let location = useLocation();
  let path = location?.pathname;
  const [openDropdown, setOpenDropdown] = useState("");
  return (
    <>
      <header className="header">
        <div className="header-top">
          <div className="container">
            <div className="header-top-wrapper">
              <div className="header-top-left">
                <div className="header-top-contact">
                  <ul>
                    <li>
                      <Link href="mailto:essexmarinepvtltd@gmail.com">
                        <i className="fa fa-envelope"></i>
                        essexmarinepvtltd@gmail.com
                      </Link>
                    </li>
                    <li>
                      <Link to="mailto:+91 3322627928">
                        <i className="fa fa-phone-volume"></i>+91 33 2262 7928
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header-top-right">
                <div className="header-top-social">
                  <span>Follow Us: </span>
                  <Link to="https://www.facebook.com/share/jdBXFgTRM1QTdmxF/">
                    <i className="fab fa-facebook"></i>
                  </Link>
                  <Link to="https://www.instagram.com/essex.marine/profilecard/?igsh=MWx5dGZvOGw5enFubQ==">
                    <i className="fab fa-instagram"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-navigation">
          <nav className="navbar navbar-expand-lg">
            <div className="container position-relative">
              <Link className="navbar-brand" to="/">
                <img src={Logo} alt="logo" />
              </Link>
              <div className="mobile-menu-right">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#main_nav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-mobile-icon">
                    <i className="fa-solid fa-bars"></i>
                  </span>
                </button>
              </div>
              <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav">
                  {[
                    {
                      name: "Home",
                      path: "/",
                    },
                    {
                      name: "About Us",
                      path: "/about-us",
                    },
                    {
                      name: "Investor",
                      // path: "/investors",
                    },
                    {
                      name: "Products",
                      path: "/products",
                    },
                    {
                      name: "Contact Us",
                      path: "/contact-us",
                    },
                  ].map((item) => (
                    <>
                      <li
                        className="nav-item"
                        style={{ position: "relative" }}
                        onMouseEnter={() =>
                          item.name === "Investor" &&
                          setOpenDropdown("Investor")
                        }
                      >
                        <Link
                          className={`nav-link ${
                            item.path == path && "active"
                          }`}
                          to={item.path}
                        >
                          {item.name}
                        </Link>
                        {openDropdown == item.name && (
                          <>
                            <InvestorDropDown />
                          </>
                        )}
                      </li>
                    </>
                  ))}
                </ul>
                <div className="nav-right">
                  <div className="nav-right-btn">
                    <Link to="/contact-us#quotes" className="theme-btn">
                      Get Quote<i className="fas fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
      <div className="sidebar-popup">
        <div className="sidebar-wrapper">
          <div className="sidebar-content">
            <button type="button" className="close-sidebar-popup">
              <i className="far fa-xmark"></i>
            </button>
            <div className="sidebar-logo">
              <img src="assets/img/logo/logo.png" alt="" />
            </div>
            <div className="sidebar-about">
              <h4>About Us</h4>
              <p>
                There are many variations of passages available sure there
                majority have suffered alteration in some form by inject humour
                or randomised words which don't look even slightly believable.
              </p>
            </div>
            <div className="sidebar-contact">
              <h4>Contact Info</h4>
              <ul>
                <li>
                  <h6>Email</h6>
                  <Link to="mailto:essexmarinepvtltd@gmail.com">
                    <i className="fa fa-envelope"></i>
                    essexmarinepvtltd@gmail.com
                  </Link>
                </li>
                <li>
                  <h6>Phone</h6>
                  <Link to="tel:+91 3322627928">
                    <i className="far fa-phone"></i>+91 33 2262 7928
                  </Link>
                </li>
                <li>
                  <h6>Address</h6>
                  <i className="far fa-location-dot"></i>25/B Milford Road, New
                  York
                </li>
              </ul>
            </div>
            <div className="sidebar-social">
              <h4>Follow Us</h4>
              <Link to="/">
                <i className="fab fa-facebook"></i>
              </Link>
              <Link to="/">
                <i className="fab fa-x-twitter"></i>
              </Link>
              <Link to="/">
                <i className="fab fa-instagram"></i>
              </Link>
              <Link to="/">
                <i className="fab fa-linkedin"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
